// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FooterToggle-iconStyle-ICLTh {
    color: var(--common-link-color);
    width: 18px;
    position: relative;
    top: -1px;
}

.FooterToggle-footerDrawerCloseOpenBtn-MimDI {
    position: fixed;
    text-align: center;
    z-index: 6;
    background-color: var(--btn-primary-color);
    border: 1px solid var(--primary-border);
    left: 15px;
    bottom: 15px;
    font-size: 16px;
    border-radius: 6px;
    cursor: pointer;
    outline: none;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    gap: 5px;
    font-weight: normal;
    -webkit-box-shadow: 0px 8px 11px var(--shadow-4);
            box-shadow: 0px 8px 11px var(--shadow-4);
    color: var(--common-link-color);
    padding: 9px 15px;
    -webkit-transition: background-color 0.25s ease, -webkit-transform 0.25s ease;
    transition: background-color 0.25s ease, -webkit-transform 0.25s ease;
    transition: background-color 0.25s ease, transform 0.25s ease;
    transition: background-color 0.25s ease, transform 0.25s ease, -webkit-transform 0.25s ease;
}

.FooterToggle-footerDrawerCloseBtn-ISRHP {
    z-index: 9;
}

/* Drawer container */

.FooterToggle-footerCustomDrawerContainer-PUEHZ {
    position: relative;
    z-index: 8;
}

/* Drawer */

.FooterToggle-footerCustomDrawer-Y5pqe {
    width: 100%;
    height: 350px;
    background: var(--common-gray-bg-color);
    overflow-y: auto;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 8;
    -webkit-transform: translateY(100%);
        -ms-transform: translateY(100%);
            transform: translateY(100%);
    opacity: 0;
    -webkit-transition: opacity 0.35s ease,
        -webkit-transform 0.35s ease;
    transition: opacity 0.35s ease,
        -webkit-transform 0.35s ease;
    transition: transform 0.35s ease,
        opacity 0.35s ease;
    transition: transform 0.35s ease,
        opacity 0.35s ease,
        -webkit-transform 0.35s ease;
}

.FooterToggle-footerDrawerOpen-yREyw {
    -webkit-transform: translateY(0);
        -ms-transform: translateY(0);
            transform: translateY(0);
    opacity: 1;
}

/* Overlay */

.FooterToggle-footerCustomDrawerOverlay-qct7G {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    opacity: 0;
    pointer-events: none;
    -webkit-transition: opacity 0.35s ease;
    transition: opacity 0.35s ease;
}

.FooterToggle-footerCustomDrawerOverlayOpen-fn4zY {
    opacity: 1;
    pointer-events: all;
}

/* Responsive button round */

@media (max-width: 991px) {
    .FooterToggle-footerDrawerCloseOpenBtn-MimDI {
        border-radius: 50%;
        padding: 9px;
        width: 40px;
        height: 40px;
    }

    .FooterToggle-footerIconText-Uld68 {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/FooterToggle/FooterToggle.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;IAC/B,WAAW;IACX,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,0CAA0C;IAC1C,uCAAuC;IACvC,UAAU;IACV,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,QAAQ;IACR,mBAAmB;IACnB,gDAAwC;YAAxC,wCAAwC;IACxC,+BAA+B;IAC/B,iBAAiB;IACjB,6EAA6D;IAA7D,qEAA6D;IAA7D,6DAA6D;IAA7D,2FAA6D;AACjE;;AAEA;IACI,UAAU;AACd;;AAEA,qBAAqB;;AACrB;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA,WAAW;;AACX;IACI,WAAW;IACX,aAAa;IACb,uCAAuC;IACvC,gBAAgB;IAChB,eAAe;IACf,OAAO;IACP,QAAQ;IACR,SAAS;IACT,UAAU;IACV,mCAA2B;QAA3B,+BAA2B;YAA3B,2BAA2B;IAC3B,UAAU;IACV;oCACsB;IADtB;oCACsB;IADtB;0BACsB;IADtB;;oCACsB;AAC1B;;AAEA;IACI,gCAAwB;QAAxB,4BAAwB;YAAxB,wBAAwB;IACxB,UAAU;AACd;;AAEA,YAAY;;AACZ;IACI,eAAe;IACf,QAAQ;IACR,8BAA8B;IAC9B,UAAU;IACV,oBAAoB;IACpB,sCAA8B;IAA9B,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA,4BAA4B;;AAC5B;IACI;QACI,kBAAkB;QAClB,YAAY;QACZ,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".iconStyle {\n    color: var(--common-link-color);\n    width: 18px;\n    position: relative;\n    top: -1px;\n}\n\n.footerDrawerCloseOpenBtn {\n    position: fixed;\n    text-align: center;\n    z-index: 6;\n    background-color: var(--btn-primary-color);\n    border: 1px solid var(--primary-border);\n    left: 15px;\n    bottom: 15px;\n    font-size: 16px;\n    border-radius: 6px;\n    cursor: pointer;\n    outline: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 5px;\n    font-weight: normal;\n    box-shadow: 0px 8px 11px var(--shadow-4);\n    color: var(--common-link-color);\n    padding: 9px 15px;\n    transition: background-color 0.25s ease, transform 0.25s ease;\n}\n\n.footerDrawerCloseBtn {\n    z-index: 9;\n}\n\n/* Drawer container */\n.footerCustomDrawerContainer {\n    position: relative;\n    z-index: 8;\n}\n\n/* Drawer */\n.footerCustomDrawer {\n    width: 100%;\n    height: 350px;\n    background: var(--common-gray-bg-color);\n    overflow-y: auto;\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 8;\n    transform: translateY(100%);\n    opacity: 0;\n    transition: transform 0.35s ease,\n        opacity 0.35s ease;\n}\n\n.footerDrawerOpen {\n    transform: translateY(0);\n    opacity: 1;\n}\n\n/* Overlay */\n.footerCustomDrawerOverlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.5);\n    opacity: 0;\n    pointer-events: none;\n    transition: opacity 0.35s ease;\n}\n\n.footerCustomDrawerOverlayOpen {\n    opacity: 1;\n    pointer-events: all;\n}\n\n/* Responsive button round */\n@media (max-width: 991px) {\n    .footerDrawerCloseOpenBtn {\n        border-radius: 50%;\n        padding: 9px;\n        width: 40px;\n        height: 40px;\n    }\n\n    .footerIconText {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconStyle": `FooterToggle-iconStyle-ICLTh`,
	"footerDrawerCloseOpenBtn": `FooterToggle-footerDrawerCloseOpenBtn-MimDI`,
	"footerDrawerCloseBtn": `FooterToggle-footerDrawerCloseBtn-ISRHP`,
	"footerCustomDrawerContainer": `FooterToggle-footerCustomDrawerContainer-PUEHZ`,
	"footerCustomDrawer": `FooterToggle-footerCustomDrawer-Y5pqe`,
	"footerDrawerOpen": `FooterToggle-footerDrawerOpen-yREyw`,
	"footerCustomDrawerOverlay": `FooterToggle-footerCustomDrawerOverlay-qct7G`,
	"footerCustomDrawerOverlayOpen": `FooterToggle-footerCustomDrawerOverlayOpen-fn4zY`,
	"footerIconText": `FooterToggle-footerIconText-Uld68`
};
module.exports = ___CSS_LOADER_EXPORT___;
